<div *ngIf="showRulesException" class="d-flex flex-row player-rule-error">
  <div><span class="ic-exclamation-red"></span></div>
  <div class="flex-grow-1 ml-2">
    <div *ngIf="rules.courtBookingNotAllowed">{{rules.courtBookingNotAllowedMessage}}</div>
    <div *ngIf="rules.daysAheadLimitExceeded">{{rules.daysAheadLimitExceededMessage}}</div>
    <div *ngIf="rules.maxMinutesPerDayExceeded">{{rules.maxMinutesPerDayExceededMessage}}</div>
    <div *ngIf="rules.maxBookingsPerDayExceeded">{{rules.maxBookingsPerDayExceededMessage}}</div>
    <div *ngIf="rules.bookingPrimeTimeExceeded">{{rules.bookingPrimeTimeExceededMessage}}</div>
    <div *ngIf="rules.maxBookingsTotalExceeded">{{rules.maxBookingsTotalExceededMessage}}</div>
  </div>
</div>
